import { HistoryMessageItem } from '@wui/im'
import { unix } from 'dayjs'

export const findFirstEventIdOfDay = (
  events: HistoryMessageItem[] | undefined,
  dayTimestamp: number,
): number | undefined => {
  if (!events?.length || !dayTimestamp) {
    return undefined
  }

  const targetDay = unix(dayTimestamp).tz()
  const event = events.find((item) => (
    Boolean(item.timestamp) && unix(item.timestamp).tz().isSame(targetDay, 'day')
  ))

  return event?.eventId
}
